'use strict';

angular.module('app.referencePoints', [])
    .controller('referencePointsCtrl', ['$scope', '$modal', 'referencePointsService',
        function ($scope, $modal, referencePointsService) {
            var month = new Date().getMonth();
            var year = new Date().getFullYear();

            $scope.period = [];
            referencePointsService.getAllPeriodOfReferencePoints(true)
                .then(function(response) {
                    $scope.period = response.data;
                    loadData($scope.period[$scope.period.length - 1].value);
                }, function(response) {
                    var errorModalInstance = $modal.open({
                        scope: $scope,
                        templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                        windowClass: 'modal-dialog-mention-error'
                    });
                    $scope.errorModalInstance = errorModalInstance;
                    $scope.errorMessage = response.message;
            })


            $scope.changePeriod = function (params) {
                loadData(params.value);
            }

            function loadData(params) {
                var params = {
                    month: params
                }

                $scope.referencePoints = [];
                referencePointsService.getReferencePoints(params, true)
                    .then(function(response) {
                        angular.forEach(response.data, function(item) {
                            item.uv_per_visit = item.uv_per_visit.toFixed(3);
                            item.share_uv_per_url = item.share_uv_per_url.toFixed(3);
                            item.impression_per_uv = item.impression_per_uv.toFixed(3);
                            item.avg_engagement = item.avg_engagement.toFixed(3);
                            $scope.referencePoints.push(item);
                            $scope.currentPeriod = item.month;
                        });

                        angular.forEach($scope.period, function (item) {
                            if ($scope.currentPeriod === item.value) {
                                item.ticked = true;
                            }
                        })
                    }, function(response) {
                        var errorModalInstance = $modal.open({
                            scope: $scope,
                            templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                            windowClass: 'modal-dialog-mention-error'
                        });
                        $scope.errorModalInstance = errorModalInstance;
                        $scope.errorMessage = response.message;
                    })
            }     

            $scope.updateReferencePoints = function(){
                var updateReferencePointsModalInstance = $modal.open({
                    scope: $scope,
                    templateUrl: 'app/admin/referencePoints/updateReferencePoints/updateReferencePoints.html?app_v=deployDate',
                    controller: 'updateReferencePointsCtrl'
                });

                $scope.updateReferencePointsModalInstance = updateReferencePointsModalInstance;
            }

            $scope.resetReferencePoints = function(){
                loadData($scope.currentPeriod);
            }
}])

